import { Component, OnInit, DoCheck } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

import { Order, OrderDish, OrderReservation } from '../../models/order';
import { Reservation } from '../../models/reservation';

import { ReservationService } from '../../services/reservation.service';
import { OrderService } from '../../services/order.service';

@Component({
  selector: 'app-order',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.css']
})

export class OrderComponent implements OnInit {
  errorMessage: string;
  orderId: number;
  foundOrder: Order;
  isSearching = false;

  constructor(private reservationService: ReservationService, private orderService: OrderService, private router: Router, private route: ActivatedRoute) {

  }

  ngOnInit() {
    let id = this.route.snapshot.paramMap.get('id');
    if(id) {
      this.orderId = +id;
      this.searchOrder();
    }
  }

  searchOrder() {
    this.foundOrder = null;
    this.errorMessage = '';
    this.isSearching = true;
    this.orderService.getOrder(this.orderId).subscribe(order => {
      this.foundOrder = order;
      this.orderId = null;
      this.isSearching = false;
    }, err => {
      if (err.status === 404) {
        this.errorMessage = 'Reservatie niet gevonden';
      } else {
        this.errorMessage = 'Error: ' + err.error + ' (' + err.status + ')';
      }
      console.log(this.errorMessage);
      this.isSearching = false;
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/krist/source/repos/FoodButtler.App/src/app/pages/order/order.component.ts